module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//green_1.png?v=0c4657ab";